import { useEffect } from 'react';

/**
 * 新しいバージョンのアプリが見つかった場合にページをリロードする
 */
export const useReloadIfNewVersionFound = () => {
  useEffect(() => {
    // FIXME: This file could not be written as TS.
    //        Give `window.workbox` and `window.workbox.messageSkipWaiting` types.
    //        See: https://www.notion.so/eversteel/spike-PWA-c8993054f29f427380ab569d9e48dd84#909f7ca5ea244770a75453c07f1c4ded
    const wb = (window as any).workbox; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (
      // See: https://github.com/shadowwalker/next-pwa/blob/1e6af5fa9f6a807930f451adb5ab5078d5cda451/examples/lifecycle/pages/index.js#L8
      // prettier-ignore
      typeof window !== 'undefined' && 'serviceWorker' in navigator && wb !== undefined
    ) {
      // See: https://developer.chrome.com/docs/workbox/handling-service-worker-updates/
      const promptNewVersionAvailable = () => {
        // MEMO: somhow; 5 minute update delay.
        // See https://www.notion.so/eversteel/spike-PWA-c8993054f29f427380ab569d9e48dd84#fb585f6eb4554b9ba69dfa7540917d5f
        // prettier-ignore
        wb.addEventListener('controlling', () => { window.location.reload(); });

        // Send a message to the waiting service worker, instructing it to activate.
        wb.messageSkipWaiting();
      };

      wb.addEventListener('waiting', promptNewVersionAvailable);

      wb.register();
    }
  }, []);
};
